import './monitoring-table.scss';

import * as api from 'config/endpoints';

import React, { useEffect, useState } from 'react';
import { getAbsoluteURL, patchData } from 'services/api-utils';

import Moment from 'moment';
import ProcessDetail from 'shared/ProcessDetail';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';

const MonitoringTable = (props) => {
  const [processPopupActive, setProcessPopupActive] = useState(false);
  const [toggledProcessUrl, setToggledProcessUrl] = useState('');
  const [toggledLifecycleProcessId, setToggledLifecycleProcessId] = useState('');
  const [toggledLifecycleStage, setToggledLifecycleStage] = useState('');
  const [updatingId, setUpdatingId] = useState('');
  const [updatingCommentId, setUpdatingCommentId] = useState('');
  const [focusedCommentId, setFocusedCommentId] = useState('');

  useEffect(() => {}, []);

  const updateProcessPopupContentValue = async (processId, commentData) => {
    setUpdatingCommentId(processId);
    commentData = commentData.replace(/[\r\n\v]+/g, '');

    const data = {
      comment: commentData,
    };

    const patchRuleEndpoint = `${api.MONITORING_PROCESS_API_ENDPOINT}${processId}/`;
    await patchData(patchRuleEndpoint, data);
    await props.triggerReloadContentNoReset();
    setTimeout(async () => {
      setFocusedCommentId('');
      setUpdatingCommentId('');
    }, 1000);
  };

  const updateFocusedCommentId = (processId) => {
    setFocusedCommentId(processId);
  };

  const updateSignOffStatus = async (processId, controlReportStatus) => {
    if (updatingId === '') {
      setUpdatingId(processId);
      const status =
        controlReportStatus === 'Awaiting Sign-Off' ? 'Signed-Off' : 'Awaiting Sign-Off';
      const data = {
        monitoring_report_status: status,
      };
      const patchRuleEndpoint = `${api.MONITORING_PROCESS_API_ENDPOINT}${processId}/`;
      await patchData(patchRuleEndpoint, data);
      await props.triggerReloadContentNoReset();
      setTimeout(async () => {
        setUpdatingId('');
      }, 1000);
    }
  };

  const toggleRuleDocumentDetailsPopup = (ruleNumber, documentRuleType) => {
    let sectionEndpoint = '';
    if (documentRuleType === 'Risk') {
      sectionEndpoint = api.RISK_PROCESS_API_ENDPOINT;
    }
    if (documentRuleType === 'Policy') {
      sectionEndpoint = api.POLICY_PROCESS_API_ENDPOINT;
    }
    if (documentRuleType === 'Procedure') {
      sectionEndpoint = api.PROCEDURE_PROCESS_API_ENDPOINT;
    }
    if (documentRuleType === 'Evidence') {
      sectionEndpoint = api.EVIDENCE_PROCESS_API_ENDPOINT;
    }

    setToggledLifecycleProcessId(ruleNumber ? ruleNumber : '');
    let absoluteURL = getAbsoluteURL(`${sectionEndpoint}${ruleNumber}/`);

    ruleNumber && sectionEndpoint !== ''
      ? setToggledProcessUrl(absoluteURL)
      : setToggledProcessUrl('');

    documentRuleType ? setToggledLifecycleStage(documentRuleType) : setToggledLifecycleStage('');

    setProcessPopupActive(!processPopupActive);
  };

  const tempCommentsData = [];

  return (
    <>
      {processPopupActive && (
        <ProcessDetail
          lifecycleProcessUrl={toggledProcessUrl}
          lifecycleProcessId={toggledLifecycleProcessId}
          microProcessId={props.microRegulatoryProcessData.id}
          lifecycleStage={toggledLifecycleStage}
          closePopup={() => toggleRuleDocumentDetailsPopup()}
          triggerReloadContent={() => props.triggerReloadContent()}
        />
      )}
      <Table className="monitoring-table">
        <TableHead>
          <TableRow key="monitoring-table">
            <TableCell style={{ maxWidth: 200 }}>Reg Doc</TableCell>
            <TableCell style={{ width: 120 }}>Rule Number</TableCell>
            <TableCell style={{ width: 70 }}>Risk</TableCell>
            <TableCell style={{ width: 70 }}>Policy</TableCell>
            <TableCell style={{ width: 70 }}>Procedure</TableCell>
            <TableCell style={{ width: 70 }}>Evidence</TableCell>
            <TableCell style={{ width: 70 }}>Control</TableCell>
            <TableCell style={{ width: 130 }}>Sign Off Status</TableCell>
            <TableCell style={{ width: 200 }}>Approved By</TableCell>
            <TableCell style={{ width: 230 }}>Comments</TableCell>
            <TableCell style={{ width: 90 }}>Monitoring Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.monitoringProcesses !== undefined &&
            props.monitoringProcesses.map((monitoringProcess, i) => {
              const signedOff = monitoringProcess.monitoring_report_status === 'Signed-Off';
              const docRule =
                monitoringProcess.company_micro_regulatory_process.micro_regulatory_process
                  .regulation_document_sub_rule.regulation_document_rule;

              const riskStatus = monitoringProcess.risk_validation_status;
              const policyStatus = monitoringProcess.policy_validation_status;
              const procedureStatus = monitoringProcess.procedure_validation_status;
              const evidenceStatus = monitoringProcess.evidence_validation_status;
              const controlStatus = monitoringProcess.control_validation_status;

              tempCommentsData.push(monitoringProcess.comment);

              return (
                <TableRow key={i}>
                  <TableCell style={{ maxWidth: 200 }}>
                    {
                      docRule.regulation_document_rule_group.regulation_document_section
                        .regulation_document.name
                    }
                  </TableCell>
                  <TableCell style={{ width: 120 }}>{docRule.rule_number}</TableCell>
                  <TableCell
                    style={{ width: 70 }}
                    className={`rule-status-item`}
                    onClick={() => toggleRuleDocumentDetailsPopup(monitoringProcess.id, 'Risk')}
                  >
                    <span className={riskStatus === 'Failed' ? 'failed' : 'passed'}>
                      {riskStatus}
                    </span>
                  </TableCell>
                  <TableCell
                    style={{ width: 70 }}
                    className={`rule-status-item`}
                    onClick={() => toggleRuleDocumentDetailsPopup(monitoringProcess.id, 'Policy')}
                  >
                    <span className={policyStatus === 'Failed' ? 'failed' : 'passed'}>
                      {policyStatus}
                    </span>
                  </TableCell>
                  <TableCell
                    style={{ width: 70 }}
                    className={`rule-status-item`}
                    onClick={() =>
                      toggleRuleDocumentDetailsPopup(monitoringProcess.id, 'Procedure')
                    }
                  >
                    <span className={procedureStatus === 'Failed' ? 'failed' : 'passed'}>
                      {procedureStatus}
                    </span>
                  </TableCell>
                  <TableCell
                    style={{ width: 70 }}
                    className={`rule-status-item`}
                    onClick={() => toggleRuleDocumentDetailsPopup(monitoringProcess.id, 'Evidence')}
                  >
                    <span className={evidenceStatus === 'Failed' ? 'failed' : 'passed'}>
                      {evidenceStatus}
                    </span>
                  </TableCell>
                  <TableCell style={{ width: 70 }} className={`rule-status-item`}>
                    <span className={controlStatus === 'Failed' ? 'failed' : 'passed'}>
                      {controlStatus}
                    </span>
                  </TableCell>
                  <TableCell
                    onClick={() =>
                      updateSignOffStatus(
                        monitoringProcess.id,
                        monitoringProcess.monitoring_report_status,
                      )
                    }
                    style={{ width: 130 }}
                    className={`rule-status-item`}
                  >
                    {updatingId === monitoringProcess.id && (
                      <div className="loading-tab">
                        <div className="loading-icon"></div>
                      </div>
                    )}
                    {updatingId !== monitoringProcess.id && (
                      <div
                        className={`status-button ${
                          signedOff ? 'signed-off' : 'awaiting-sign-off'
                        }`}
                      >
                        {signedOff ? 'SIGNED OFF' : 'SIGN OFF?'}
                      </div>
                    )}
                  </TableCell>
                  <TableCell style={{ width: 200 }}>
                    {monitoringProcess.last_reviewed_by !== null &&
                    monitoringProcess.last_reviewed_by.username
                      ? monitoringProcess.last_reviewed_by.username
                      : '—'}
                    <br />
                    {Moment(monitoringProcess.last_reviewed).format('MMM Do YYYY, h:mm a')}
                  </TableCell>
                  <TableCell style={{ width: 230 }}>
                    {updatingCommentId !== monitoringProcess.id && (
                      <>
                        <TextField
                          className="input-text-comment"
                          type="text"
                          variant="outlined"
                          defaultValue={tempCommentsData[i]}
                          multiline
                          spellCheck={false}
                          rows={3}
                          onFocus={() => updateFocusedCommentId(monitoringProcess.id)}
                          onBlur={() => setFocusedCommentId('')}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              updateProcessPopupContentValue(monitoringProcess.id, e.target.value);
                            }
                          }}
                        />
                        {focusedCommentId === monitoringProcess.id && (
                          <div
                            style={{
                              fontSize: 9,
                              width: '100%',
                              textAlign: 'center',
                              paddingTop: 2,
                              marginBottom: -16,
                            }}
                          >
                            Press ENTER to save comment
                          </div>
                        )}
                      </>
                    )}
                    {updatingCommentId === monitoringProcess.id && (
                      <div className="loading-icon"></div>
                    )}
                  </TableCell>
                  <TableCell style={{ width: 90 }} className={`rule-status-item`}>
                    <span
                      className={
                        monitoringProcess.validation_status === 'Failed' ? 'failed' : 'passed'
                      }
                    >
                      {monitoringProcess.validation_status}
                    </span>
                  </TableCell>
                </TableRow>
              );
            })}
        </TableBody>
      </Table>
    </>
  );
};

MonitoringTable.defaultProps = {};

export default MonitoringTable;
